var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMonitorPlay = function SvgIconMonitorPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.625 11.25-3.75-2.625v5.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M22 16.5a2.5 2.5 0 0 1-2.5 2.5h-15A2.5 2.5 0 0 1 2 16.5V6a2.5 2.5 0 0 1 2.5-2.5h15A2.5 2.5 0 0 1 22 6zm-2.5.5a.5.5 0 0 0 .5-.5V6a.5.5 0 0 0-.5-.5h-15A.5.5 0 0 0 4 6v10.5a.5.5 0 0 0 .5.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 20.375a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2z"
  }))));
};
export default SvgIconMonitorPlay;